// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"21":"a873ef52016b2101","263":"6b5818c83c3cb9a4"}[chunkId] + ".js";
};